import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import Table from "react-bootstrap/Table";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import toast, { Toaster } from "react-hot-toast";
import Form from "react-bootstrap/Form";
import { Button, Modal } from "react-bootstrap";
import { ApprovalStatus } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { useForm } from "react-hook-form";
import classNames from "classnames";

library.add(fas);

const statusOptions = [
  { label: "All", value: "" },
  { label: "Pending", value: String(ApprovalStatus.Pending) },
  { label: "Approved", value: String(ApprovalStatus.Approved) },
  { label: "Rejected", value: String(ApprovalStatus.Rejected) },
];

const Tables = () => {
  const { getData, postData, Per_Page_Dropdown, IMG_URL } = useContext(Context);

  const {
    register,
    reset: formReset,
    handleSubmit,
    formState: { errors: formError },
  } = useForm();

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [type, setType] = useState(statusOptions[0]);
  const [loading, setLoading] = useState(false);

  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [rejectId, setRejectId] = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [approveRequest, setApproveRequest] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const getDataAll = async () => {
    setLoading(true);

    const response = await getData(
      `/admin/wallet/fund-request?page=${onPageChange}&per_page=${perPage}&term=${search || ""}&type=${type?.value || ""}&startDate=${startDate}&endDate=${endDate}`,
    );
    await setData(response);

    if (response?.success) {
      setLoading(false);
    }
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);

    setOption(await Per_Page_Dropdown(response?.data?.total));
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const submitStatus = async (id, body) => {
    setSubmitting(true);
    const response = await postData(`/admin/wallet/fund-request/${id}`, body);

    if (response?.success) {
      await setShowModal({ code: response.code, message: response.data });
      setShowRemarkModal(false);
      setShowApproveModal(false);
      setRejectId(null);
      setApproveRequest(null);
      formReset();
    } else {
      await setShowModal({ code: response?.code, message: response?.errors });
    }

    setTimeout(() => {
      setShowModal(0);
    }, 1000);
    setChangeStatus(response);
    setSubmitting(false);
  };

  const handleStatusChange = (value, request) => {
    if (Number(value) === ApprovalStatus.Rejected) {
      setRejectId(request.id);
      setShowRemarkModal(true);
    } else if (Number(value) === ApprovalStatus.Approved) {
      setApproveRequest(request);
      setShowApproveModal(true);
    }
  };

  const handleApprove = () =>
    submitStatus(approveRequest.id, { status_id: ApprovalStatus.Approved });

  const handleRejectSubmit = (formData) =>
    submitStatus(rejectId, {
      status_id: ApprovalStatus.Rejected,
      remark: formData?.remark,
    });

  const statusClass = (statusId) => {
    if (Number(statusId) === ApprovalStatus.Approved) return "text-success";
    if (Number(statusId) === ApprovalStatus.Rejected) return "text-danger";
    return "text-warning";
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Fund Request"} link={"/admin/wallet/fund-request"} />
        <section className="AdvanceDashboard">
          <section className="Tabels tab-radio tab-radio mt-3">
            <div className="">
              <div className="row p-2">
                <div className="border-line mt-3"></div>

                <div className="row mt-4">
                  <div className=" col-12">
                    <div className="">
                      <div className="  top-showing-wrapper sowing ms-3 me-2">
                        <p className="show m-0">Show</p>
                        <select
                          className="form-select form-select-sm"
                          aria-label=".form-select-sm example"
                          onChange={(e) => {
                            setonPageChange(1);
                            setperPage(e.target.value);
                          }}
                        >
                          {option?.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        <p className="show m-0">
                          entries{" "}
                          {`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1,
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.total,
                          )} of ${data?.data?.total} entries`}
                        </p>
                      </div>
                    </div>

                    <div className="row align-items-end">
                      <div
                        className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        Search
                        <div className="num">
                          <Form.Control
                            type="text"
                            placeholder="Name, email or contact"
                            value={search || ""}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                        </div>
                      </div>

                      <div
                        className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        From
                        <div className="num">
                          <Form.Control
                            type="date"
                            min="0001-01-01"
                            max="9999-12-31"
                            className="form-control"
                            placeholder="Start Date"
                            value={startDate}
                            onChange={(e) => {
                              setStartDate(e.target.value);
                              setEndDate("");
                              setonPageChange(1);
                            }}
                          />
                        </div>
                      </div>

                      <div
                        className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6  col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        To
                        <div className="num">
                          <Form.Control
                            type="date"
                            className="form-control"
                            min={startDate ? startDate : "0001-01-01"}
                            max="9999-12-31"
                            placeholder="to"
                            value={endDate}
                            onChange={(e) => {
                              setEndDate(e.target.value);
                              setonPageChange(1);
                            }}
                          />
                        </div>
                      </div>

                      <div
                        className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6  col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        Status
                        <div className="num">
                          <Select
                            options={statusOptions}
                            value={type}
                            onChange={(e) => setType(e)}
                            placeholder="Status"
                          />
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                        <div className="Search me-2">
                          <Button
                            type="button"
                            onClick={() => {
                              setonPageChange(1);
                              getDataAll();
                            }}
                            className="btn btn-search"
                          >
                            Search
                          </Button>
                        </div>
                        <div className="Search-1">
                          <button
                            type="button"
                            onClick={() => {
                              setSearch("");
                              setStartDate("");
                              setEndDate("");
                              setType(statusOptions[0]);
                              setonPageChange(1);
                              setReset(!reset);
                            }}
                            className="btn btn-reset"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-line mt-3"></div>
              <div className="row mt-3 p-1">
                <div className="data table-responsive">
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th className="sr" style={{ width: "6%" }}>
                          Sr. No.
                        </th>
                        <th className="tax-name">Date Time</th>
                        <th className="tax-name">Customer Name</th>
                        <th className="tax-name">Amount</th>
                        <th className="tax-name">Transaction ID</th>
                        <th className="tax-name">Payment Proof</th>
                        <th className="tax-name">Status</th>
                        <th className="tax-name">Remark</th>
                        <th className="tax-name" style={{ width: "140px" }}>
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        data?.data?.data?.map((d, index) => {
                          const paginatedIndex =
                            (onPageChange - 1) * perPage + index + 1;
                          return (
                            <tr key={d.id}>
                              <td>{paginatedIndex}.</td>
                              <td>
                                {new Date(d?.createdAt).toLocaleString(
                                  "en-IN",
                                  {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: false,
                                  },
                                )}
                              </td>
                              <td>{d?.User?.name}</td>
                              <td>₹ {d?.amount}</td>
                              <td>{d?.transaction_id}</td>
                              <td>
                                {d?.payment_proof ? (
                                  <a
                                    href={IMG_URL + d.payment_proof}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    View
                                  </a>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td className={statusClass(d?.status_id)}>
                                {d?.Approval_Status?.name || "_"}
                              </td>
                              <td>{d?.admin_remark || "-"}</td>
                              <td>
                                {d?.status_id === ApprovalStatus.Pending && (
                                  <select
                                    style={{ width: "100px" }}
                                    value=""
                                    onChange={(e) =>
                                      handleStatusChange(e.target.value, d)
                                    }
                                    className="form-select"
                                  >
                                    <option value="">Select</option>
                                    <option value={ApprovalStatus.Approved}>
                                      Accept
                                    </option>
                                    <option value={ApprovalStatus.Rejected}>
                                      Reject
                                    </option>
                                  </select>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                  {data && data?.data?.data?.length > 0 ? (
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  ) : (
                    <p className="no-datashow">Sorry, No Data Found</p>
                  )}
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>

      <Modal
        show={showApproveModal}
        onHide={() => setShowApproveModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Acceptance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <h5>Accept this fund request?</h5>
            <p className="text-muted mb-0">
              <strong>₹ {approveRequest?.amount}</strong> will be credited to{" "}
              <strong>{approveRequest?.User?.name}</strong>'s wallet.
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowApproveModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            disabled={submitting}
            onClick={handleApprove}
          >
            Yes, Accept
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRemarkModal}
        onHide={() => setShowRemarkModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Reject Fund Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Remark</Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter reason for rejection..."
              maxLength={250}
              className={classNames("", {
                "is-invalid": formError?.remark,
              })}
              {...register("remark", {
                required: "Remark is required",
                maxLength: {
                  value: 250,
                  message: "Remark cannot exceed 250 characters",
                },
                validate: (value) =>
                  value?.trim()?.length > 0 || "Remark is required",
              })}
            />

            {formError?.remark && (
              <span className="text-danger">{formError?.remark?.message}</span>
            )}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRemarkModal(false)}>
            Cancel
          </Button>
          <Button
            variant="danger"
            disabled={submitting}
            onClick={handleSubmit(handleRejectSubmit)}
          >
            Reject
          </Button>
        </Modal.Footer>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
